import BenchlingConfig from 'BenchlingConfig';

export default function isExperimentOptimizationEnabled(): boolean {
  return BenchlingConfig.MACHINE_LEARNING_ENABLE_EXPERIMENT_OPTIMIZATION;
}
